import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SiteProvider } from "@/context/SiteContext";
import { Header } from "./Header";
import { Footer } from "./Footer";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default function PublicLayout() {
  return (
    <SiteProvider>
      <ScrollTop />
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[60] bg-[#0055FF] px-4 py-2">Skip to content</a>
      <div className="min-h-screen flex flex-col bg-[#050505]">
        <Header />
        <main id="main" className="flex-1">
          <Outlet />
        </main>
        <Footer />
      </div>
    </SiteProvider>
  );
}
